import type { ParsedUser } from '@/utils/parsePastedUsers.ts';

/**
 * A parsed person with an identity of its own.
 *
 * The list is edited and rows are removed from the middle of it, so the array
 * index is not identity: keying on it makes the field of the row below inherit
 * the text of the one that was deleted.
 */
export interface ImportRow extends ParsedUser {
  key: string;
}

let counter = 0;

export function toImportRows(users: ParsedUser[]): ImportRow[] {
  return users.map((user) => ({ ...user, key: `row-${(counter += 1)}` }));
}
